var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._v("\n  " + _vm._s(_vm.$t("kanbanCardCell")) + "\n  "),
      _vm.isBoardNotInSelectedAccount
        ? _c("div", { staticClass: "small text-muted" }, [
            _vm._v(_vm._s(_vm.$t("workflow.card.cellInDifferentAccount")))
          ])
        : _c("vSelect", {
            attrs: {
              options: _vm.cellStore.cellsForVSelect,
              label: "name",
              reduce: e => e.id,
              appendToBody: true,
              "calculate-position": _vm.vSelectInModalWithPopper
            },
            model: {
              value: _vm.cellId,
              callback: function($$v) {
                _vm.cellId = $$v
              },
              expression: "cellId"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }